"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCostLayerCreateInputSchema = exports.APosCostLayerSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosCostLayerSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    costLayerId: id_schema_1.EntityIdSchema,
    variantId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    unitCost: zod_1.z.number().nonnegative(),
    initialQuantity: zod_1.z.number().int().positive(),
    remainingQuantity: zod_1.z.number().int().nonnegative(),
    sourceType: zod_1.z.enum(['grn', 'purchase_order', 'transfer_in', 'return', 'adjustment']),
    sourceId: id_schema_1.EntityIdSchema,
    receivedAt: zod_1.z.number(),
    fifoRank: zod_1.z.number().int().nonnegative(),
    isDepleted: zod_1.z.boolean().default(false),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosCostLayerCreateInputSchema = zod_1.z.object({
    variantId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    unitCost: zod_1.z.number().nonnegative(),
    initialQuantity: zod_1.z.number().int().positive(),
    sourceType: zod_1.z.enum(['grn', 'purchase_order', 'transfer_in', 'return', 'adjustment']),
    sourceId: id_schema_1.EntityIdSchema,
});
//# sourceMappingURL=cost-layer.schema.js.map